import { httpClient } from '../httpClient';

export const adminDmoApi = {
  listDMOs: () =>
    httpClient.get('/admin/dmo'),

  createDMO: (data) =>
    httpClient.post('/admin/dmo', data),

  updateDMO: (id, data) =>
    httpClient.patch(`/admin/dmo/${id}`, data),

  deleteDMO: (id) =>
    httpClient.delete(`/admin/dmo/${id}`),
};
